import { render, staticRenderFns } from "./ThumbTagging.vue?vue&type=template&id=6aa7e916&scoped=true&"
import script from "./ThumbTagging.vue?vue&type=script&lang=js&"
export * from "./ThumbTagging.vue?vue&type=script&lang=js&"
import style0 from "./ThumbTagging.vue?vue&type=style&index=0&id=6aa7e916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7e916",
  null
  
)

export default component.exports